import { ClinicalSpecialistIcon, SurgeonIcon, TxDelegateIcon } from '@icons';
import { MdOutlineFileCopy } from 'react-icons/md';
import { Button, TmdxAvatar, useDisclosure } from '@ds';
import TabSection from '@features/components/CaseOverview/components/TabSection/TabSection';
import { SectionMiniCard } from '../components/SectionMiniCard';
import { getClinicalRecordByType, getUnosId } from '@/utils/helpers';
import { Case, ClinicalItemType } from '@/api/apis/case';
import { ServiceConfirmationModal } from '../components/ServiceConfirmationModal/ServiceConfirmationModal';
import { ConfirmationUserCard } from '../components/ConfirmationUserCard';

export const ServiceConfirmation = ({ caseData }: { caseData: Case }) => {
  const { isOpen, onOpenChange } = useDisclosure();
  const {
    clinicalData,
    organType,
    donorId,
    reAllocationSequenceNumber,
    opoRequest,
    isExpeditedCase,
    trialProgram,
    randomization,
    additionalServices,
    laterality,
    duplicateCaseNumber,
  } = caseData;
  const confirmationData = getClinicalRecordByType(clinicalData, ClinicalItemType.ServiceConfirmation)?.item;

  const { ocsSpecialist, txRepresentative, retrievalSurgeon } = confirmationData ?? {};

  return (
    <TabSection title="Service Summary">
      <SectionMiniCard title="Service Confirmation Form" icon={<MdOutlineFileCopy size={24} />}>
        <div className="flex flex-1 flex-col justify-between gap-4">
          <div className="flex gap-1">
            <ConfirmationUserCard
              checked={!!retrievalSurgeon}
              icon={<SurgeonIcon height={24} width={24} />}
              text="Retrieval Surgery"
            />
            <ConfirmationUserCard
              checked={!!ocsSpecialist}
              icon={<ClinicalSpecialistIcon height={24} width={24} />}
              text="OCS Mgmt"
            />
            <ConfirmationUserCard
              checked={!!txRepresentative}
              icon={<TxDelegateIcon height={24} width={24} />}
              text="TX Delegate"
            />
          </div>
          <div className="flex items-center justify-between">
            <div className={`flex gap-1 truncate items-center text-m-m ${ocsSpecialist ? '' : 'opacity-50'}`}>
              <TmdxAvatar size="sm" radius="sm" type="clinical-specialist" src={ocsSpecialist?.photoPath} />
              <div className="truncate">{ocsSpecialist?.signature.fullName || 'Clinical Specialist'}</div>
            </div>
            <Button
              isDisabled={!confirmationData}
              className="h-6 min-w-0 px-2 text-xs-sb!"
              variant="outline"
              onClick={onOpenChange}
            >
              View Form
            </Button>
          </div>
        </div>
      </SectionMiniCard>
      {confirmationData && (
        <ServiceConfirmationModal
          onOpenChange={onOpenChange}
          isOpen={isOpen}
          confirmationData={confirmationData}
          organType={caseData.organType}
          unosId={getUnosId(
            donorId,
            organType,
            reAllocationSequenceNumber,
            opoRequest,
            isExpeditedCase,
            laterality,
            duplicateCaseNumber,
          )}
          clinicalData={clinicalData}
          isTrialCase={!!trialProgram}
          randomization={randomization}
          additionalServices={additionalServices}
        />
      )}
    </TabSection>
  );
};
